document.addEventListener('DOMContentLoaded', function () {
  if (!window.LoadSwiper) return;

  window.LoadSwiper.then(function (module) {
    var Swiper = module.Swiper;
    var Navigation = module.Navigation;

    var sliders = document.querySelectorAll('[data-recommended-products-slider]');
    sliders.forEach(function (slider) {
      if (!slider.swiper) {
        var root = slider.closest('[data-recommended-products]');
        var prevEl = root ? root.querySelector('.swiper-prev') : null;
        var nextEl = root ? root.querySelector('.swiper-next') : null;
        var product = root ? root.closest('.product') : null;
        var productMeta = root ? root.closest('.product__meta') : null;
        var slideCount = slider.querySelectorAll('.swiper-slide').length;
        var mobileSlidesPerView = slideCount === 1 ? 1 : 1.7;
        var desktopSlidesPerView = slideCount < 3 ? slideCount : 2.4;
        var mobileEndOffset = slideCount === 1 ? 0 : 24;
        var desktopEndOffset = slideCount < 3 ? 0 : 20;

        function updateNavState(swiper) {
          if (prevEl) {
            if (swiper.isBeginning) {
              prevEl.classList.add('swiper-nav--disabled');
            } else {
              prevEl.classList.remove('swiper-nav--disabled');
            }
          }
          if (nextEl) {
            if (swiper.isEnd) {
              nextEl.classList.add('swiper-nav--disabled');
            } else {
              nextEl.classList.remove('swiper-nav--disabled');
            }
          }
        }

        function updateStickyTopLimit() {
          if (!root) return;

          if (!product || !productMeta) return;

          if (window.innerWidth < 960) {
            product.classList.remove('product--cross-sell-sticky-safe');
            product.style.removeProperty('--pdp-cross-sell-sticky-top-max');
            productMeta.style.removeProperty('top');
            return;
          }

          var rootRect = root.getBoundingClientRect();
          var metaRect = productMeta.getBoundingClientRect();
          var rootBottomWithinMeta = rootRect.bottom - metaRect.top;
          var viewportGap = 24;
          var stickyTopMax = window.innerHeight - viewportGap - rootBottomWithinMeta;

          product.classList.add('product--cross-sell-sticky-safe');
          product.style.setProperty('--pdp-cross-sell-sticky-top-max', stickyTopMax + 'px');
          productMeta.style.setProperty(
            'top',
            'min(var(--product-meta-top, 0px), var(--pdp-cross-sell-sticky-top-max, 0px))',
            'important'
          );
        }

        new Swiper(slider, {
          modules: [Navigation],
          slidesPerView: mobileSlidesPerView,
          slidesPerGroup: 1,
          spaceBetween: 8,
          slidesOffsetAfter: mobileEndOffset,
          grabCursor: true,
          roundLengths: true,
          watchOverflow: true,
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
          breakpoints: {
            768: {
              slidesPerView: desktopSlidesPerView,
              spaceBetween: 16,
              slidesOffsetAfter: desktopEndOffset,
            },
          },
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
          on: {
            init: function (swiper) {
              updateNavState(swiper);
              updateStickyTopLimit();
            },
            slideChange: function (swiper) {
              updateNavState(swiper);
            },
            reachEnd: function (swiper) {
              if (nextEl) nextEl.classList.add('swiper-nav--disabled');
            },
            fromEdge: function (swiper) {
              updateNavState(swiper);
            },
            resize: function (swiper) {
              updateNavState(swiper);
              updateStickyTopLimit();
            },
          },
        });

        if (window.ResizeObserver && root && productMeta) {
          var stickyResizeObserver = new ResizeObserver(updateStickyTopLimit);
          stickyResizeObserver.observe(root);
          stickyResizeObserver.observe(productMeta);
        }
      }
    });
  });
});
